import styled from "styled-components";



export const PoIdLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #293142;
  text-decoration: underline;
  text-decoration-style: dotted;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const DeliveryAtCell = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  svg {
    flex-shrink: 0;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const FilterSelectBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #596378;
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120px 0;
  gap: 24px;
`;

export const EmptyStateIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border-radius: 150px;
  background: #ffffff;
`;

export const EmptyStateTitle = styled.p`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #293142;
  letter-spacing: -0.24px;
  text-align: center;
`;

export const EmptyStateMessage = styled.p`
  margin: 0;
  max-width: 296px;
  font-size: 16px;
  color: #767c8f;
  text-align: center;
  line-height: 22px;
`;

export const EmptyStateButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  background: #ef4f5f;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: ${(props) => (props.$hasDoc ? "pointer" : "not-allowed")};

  img {
    width: 16px;
    height: 16px;
  }
`;

export const StatusBoxWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const StatusBoxTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #596378;
  cursor: pointer;
`;

export const StatusChipSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
`;

export const StatusSummaryChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: #e6e9ef;
  border-radius: 4px;
  font-size: 12px;
  color: #596378;
  white-space: nowrap;
`;

export const StatusSummaryMore = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #ef4f5f;
  white-space: nowrap;
`;

export const StatusDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 10;
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  box-shadow: 0px 8px 24px rgba(28, 28, 28, 0.08);
  padding: 8px;
  max-height: 240px;
  overflow-y: auto;
`;

export const StatusOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  font-size: 14px;
  color: #293142;
  cursor: pointer;

  &:hover {
    background: #f4f6fb;
  }
`;

export const CellText = styled.span`
  font-size: 14px;
`;



export const WarehouseBoxWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const WarehouseBoxTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #596378;
  cursor: pointer;
`;

export const WarehouseDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 10;
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  box-shadow: 0px 8px 24px rgba(28, 28, 28, 0.08);
  padding: 8px;
  max-height: 280px;
  display: flex;
  flex-direction: column;
`;

export const WarehouseSearchInput = styled.input`
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #e6e9ef;
  border-radius: 6px;
  font-size: 13px;
  color: #293142;
  outline: none;
  margin-bottom: 4px;
  flex-shrink: 0;
  box-sizing: border-box;

  &::placeholder {
    color: #9197a6;
  }
`;

export const WarehouseOptionsList = styled.div`
  overflow-y: auto;
  flex: 1;
`;

export const WarehouseOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  font-size: 14px;
  color: #293142;
  cursor: pointer;

  &:hover {
    background: #f4f6fb;
  }
`;

export {
  FiltersCard,
  FiltersTitle,
  FiltersRow,
  FilterField,
  FilterLabel,
  FiltersActions,
  ApplyFiltersButton,
  ClearAllButton,
} from "components/shared/TableWithFilters/styles.tableWithFilters";
